import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=2a5670f7&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"
import style0 from "./Patient.vue?vue&type=style&index=0&id=2a5670f7&prod&lang=scss"
import style1 from "./Patient.vue?vue&type=style&index=1&id=2a5670f7&prod&lang=scss&scoped=true"
import style2 from "./Patient.vue?vue&type=style&index=2&id=2a5670f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5670f7",
  null
  
)

export default component.exports